var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tour',{attrs:{"name":"NavVTour","steps":_vm.steps,"options":{ highlight: false },"callbacks":_vm.myCallbacks}})}
var staticRenderFns = []

export { render, staticRenderFns }